import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Container, Row, Col, Table } from "react-bootstrap";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import { exportToExcel, datetime, generatePdf,} from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import { Field, FormikProvider, Form, useFormik } from "formik";
import MasterService from "../../Services/MasterService";

export default function HODAchievementsAbstractReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [data, setData] = useState([]); const [searchText, setSearch] = useState(""); const [yearList,setYearList] = useState([]);
  
  let username = localStorage.getItem("username");
  const formik = useFormik({
    initialValues: {
      year: "",
    },
  });

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
     MasterService.getfinyears().then((finachievres) => {
      if (finachievres.data) {
         let options = finachievres.data.map((item, i) => {
            return ( <option key={i} value={item.id}> {item.value} </option> );
          });
           setYearList(options);
        }
      });
  }, []);

  const getData = (year) => {
    if (!year) { showAlertMessage("Year Required", "error"); setData([]); return; }
    let kpiabstractparams = { userId: username, year:year};
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.kpisAchievementAbstractReport(kpiabstractparams)
      .then((kpiabsres) => {
        if (kpiabsres.data && kpiabsres.data.SCODE == "01") {
          setData(kpiabsres.data.SDESC);
        } else {
          setData([]);
        }
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };

  const filteredData =
    searchText.length > 0 && data?.length
      ? data.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }) );
        })
      : data;

const AreaWise = [ { name: "Secretariat" }, { name: "HOD" }, { name: "District" }, { name: "Mandal" } ]; const PeriodWise = [ { name: "Monthly" }, { name: "Quarterly" }, { name: "Half yearly" }, { name: "Annually" }, { name: "Biennial" }, { name: "Five Years" } ]; const periodSubColumns = { Monthly: [ { value: "apr", label: "Apr" }, { value: "may", label: "May" }, { value: "jun", label: "Jun" }, { value: "jul", label: "Jul" }, { value: "aug", label: "Aug" }, { value: "sep", label: "Sep" }, { value: "oct", label: "Oct" }, { value: "nov", label: "Nov" }, { value: "dec", label: "Dec" }, { value: "jan", label: "Jan" }, { value: "feb", label: "Feb" }, { value: "mar", label: "Mar" }, ], Quarterly: [ { value: "q1", label: "Q1 (Apr-Jun)" }, { value: "q2", label: "Q2 (Jul-Sep)" }, { value: "q3", label: "Q3 (Oct-Dec)" }, { value: "q4", label: "Q4 (Jan-Mar)" }, ], "Half yearly": [ { value: "hy1", label: "HY-1" }, { value: "hy2", label: "HY-2" }, ], Annually: [], Biennial: [], "Five Years": [], }; const [expandedCols, setExpandedCols] = useState([]);

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "97%" }}> <div className="sa-title"> <h2>Abstract - Finance Year Wise <span>Achievement Status Report </span> </h2> </div> </Container>
      <Container fluid style={{ width: "97%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container py-2 px-4 mb-3">
              <Row>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> Financial Year </label><span style={{ color: "red" }}> *</span>
                  <Field as="select" className="mb-3 form-control" name="year" onChange={(e) => { formik.handleChange(e); getData(e.target.value); }}  style={{ fontWeight: "bold" }} > <option value="">--Select--</option> {yearList}</Field>
                </Col>
              </Row>
            </div>
          </Form>
        </FormikProvider>

        <Row>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            <div style={{ display: "flex", border: "1px solid #ddd",  alignItems: "center",borderRadius: "20px",transition: "all 0.3s ease-in-out", backgroundColor: "#fff",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
              <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
              <input type="text" placeholder="Search" value={searchText} onChange={(e) => setSearch(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div>
          </Col>
          <Col className="mb-2">
            <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "FinanceYearWiseAchievementStatusReport")} style={{ float: "right", marginLeft: "3px" }}> PDF <MdOutlinePictureAsPdf /> </button> <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "FinanceYearWiseAchievementStatusReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
          </Col>
        </Row>

        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> <span className="style"> Finance Year Wise Achievement Status Report</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll">
          <div className="table-wrap">
        <Table bordered id="my-table" className="table table-bordered custom-table table-responsive sticky-table">
  <thead>
    <tr className="text-center"> <th  rowSpan={3}>Sl.No.</th> <th  rowSpan={3}>HOD Name</th>

      {AreaWise.map((area) => {
        const filteredPeriods = area.name === "Secretariat" ? PeriodWise.filter(p => ["Monthly", "Annually"].includes(p.name)) : PeriodWise;
        const totalPeriods = filteredPeriods.reduce((sum, period) => { const subCols = periodSubColumns[period.name] || []; const key = `${area.name}-${period.name}`; const isExpanded = expandedCols.includes(key); return sum + 2 + (isExpanded ? subCols.length : 0); }, 0) + (formik.values.year === "2025-26" ? 1 : 0); 
        return ( <th key={area.name} colSpan={totalPeriods} > {area.name} </th> );
      })}
    </tr>

    <tr className="text-center">
      {AreaWise.map((area) => { const filteredPeriods = area.name === "Secretariat" ? PeriodWise.filter(p => ["Monthly", "Annually"].includes(p.name)) : PeriodWise;

        return (
          <>
            {formik.values.year === "2025-26" && ( <th key={`${area.name}-target-header`} rowSpan={2} > Targets </th> )}
            {filteredPeriods.map((period) => { const key = `${area.name}-${period.name}`; const isExpanded = expandedCols.includes(key); const subCols = periodSubColumns[period.name] || []; const colSpan = 2 + (isExpanded ? subCols.length : 0);
              return (
                <th key={key} colSpan={colSpan} > {period.name} </th>
              );
            })}
          </>
        );
      })}
    </tr>

    <tr className="text-center">
      {AreaWise.map((area) => { const filteredPeriods = area.name === "Secretariat" ? PeriodWise.filter(p => ["Monthly", "Annually"].includes(p.name)) : PeriodWise;
        return filteredPeriods.map((period) => {
          const key = `${area.name}-${period.name}`; const isExpanded = expandedCols.includes(key); const subCols = periodSubColumns[period.name] || [];
          return (
            <>
              <th key={`${key}-mapped`} > Mapped Indicators </th>
              {isExpanded && subCols.map((sub) => ( <th key={`${key}-${sub.value}`} > {sub.label} </th> ))}
              <th key={`${key}-initiated`} style={{  cursor: subCols.length ? "pointer" : "default", }} onClick={() => subCols.length && setExpandedCols((prev) => prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key] ) } >
                Total Initiated {" "}
                {subCols.length > 0 && (
                  <span style={{ display: "inline-block", width: "15px", height: "15px", lineHeight: "15px", borderRadius: "50%", backgroundColor: isExpanded ? "red" : "#FFA600", color: "white", fontWeight: "bold", fontSize: "12px", marginLeft: "5px", }}> {isExpanded ? "−" : "+"} </span>
                )}
              </th>
            </>
          );
        });
      })}
    </tr>
  </thead>

  <tbody>
    {filteredData?.length === 0 ? (
      <tr>
        <td className="text-center" colSpan="100%">
          <b style={{ color: "red" }}>Details Not Found</b>
        </td>
      </tr>
    ) : (
      filteredData.map((detail, i) => {
        const targetKeyMap = { Secretariat: "sec_level_targets_approved_count", HOD: "hod_level_targets_approved_count", District: "district_level_targets_indicator_approved_count", Mandal: "cpo_level_targets_approved_count", };

        return (
          <tr key={i}>
            <td style={{ textAlign: "center" }}>{i + 1}</td>
            <td className="indicator-column">{detail.deptcode}-{detail?.dept_name}</td>
            {AreaWise.map((area) => { const filteredPeriods = area.name === "Secretariat" ? PeriodWise.filter(p => ["Monthly", "Annually"].includes(p.name)) : PeriodWise;

              return (
                <> {formik.values.year === "2025-26" && ( <td key={`${area.name}-target`} className="text-end"> {detail?.[targetKeyMap[area.name]] > 0 ? detail?.[targetKeyMap[area.name]] : ""} </td> )}

                  {filteredPeriods.flatMap((period) => {
                    const key = `${area.name}-${period.name}`; const isExpanded = expandedCols.includes(key); const subCols = periodSubColumns[period.name] || [];
                    const getValue = (fieldKey) => { return detail?.[fieldKey] ?? detail?.[fieldKey.replace("quarterly", "quaterly")]; };
                    const baseKey = `${area.name}_${period.name}`.toLowerCase().replace("quaterly", "quarterly").replace(/\s+/g, "_"); const mappedKey = `${baseKey}_kpis_count`; const initiatedKey = `${baseKey}_count`;

                    return [
                      <td key={`${key}-mapped`} className="text-end"> {getValue(mappedKey) > 0 ? getValue(mappedKey) : "NA"} </td>,
                      ...(isExpanded
                        ? subCols.map((sub) => {
                            const fullKey = `${baseKey}_${sub.value}_count`;
                            return ( <td key={`${key}-${sub.value}`} className="text-end"> {getValue(mappedKey)>0 ?(getValue(fullKey)>0?getValue(fullKey):"0"):"NA"} </td> );
                          })
                        : []), <td key={`${key}-initiated`} className="text-end"> {getValue(mappedKey) > 0 ? getValue(initiatedKey) === null ? "0" : getValue(initiatedKey) : "NA"} </td>,
                    ];
                  })}
                </>
              );
            })}
          </tr>
        );
      })
    )}
  </tbody>
</Table>
          </div>
        </div>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
